import { CardContent, styled } from "@mui/material";

function Card({
  onClick,
  children,
  shadow,
  minHeight,
  padding,
  maxHeight,
  marginBottom,
}) {
  return (
    <CardContentStyle
      minHeight={minHeight}
      padding={padding}
      marginBottom={marginBottom}
      maxHeight={maxHeight}
      shadow={shadow}
      onClick={onClick}
    >
      {children}
    </CardContentStyle>
  );
}

const CardContentStyle = styled(
  ({ minHeight, padding, shadow, maxHeight, ...props }) => (
    <CardContent {...props} />
  )
)(({ minHeight, padding, theme, shadow, maxHeight, marginBottom }) => ({
  minHeight: minHeight,
  maxHeight: maxHeight || "455px",
  marginBottom: marginBottom,
  background: theme.palette.background.primaryGradient,
  border: `1px solid ${theme.palette.modules.border}`,
  borderRadius: "10px",
  padding: padding,
  boxShadow: shadow || "",
  direction: "rtl",
  color: theme.palette.text.main,
}));
export default Card;
